import { useCallback } from 'react';

import {
  fetchFnsRegistrySearchInn,
  fetchFnsRegistrySearchMsp,
} from '../../../APIPackage/FnsModule/services/fnsRegistryApi';

export function useFnsRegistrySearchInn() {
  const getFnsRegistryDateInn = useCallback(async (inn: string) => {
    try {
      const response = await fetchFnsRegistrySearchInn(inn);

      return {
        success: true,
        data: response,
      };
    } catch (err) {
      return {
        success: false,
      };
    }
  }, []);

  return {
    getFnsRegistryDateInn,
  };
}

export function useFnsRegistrySearchMsp() {
  const getFnsRegistryDateMsp = useCallback(async (inn: string) => {
    try {
      const response = await fetchFnsRegistrySearchMsp(inn);

      return {
        success: true,
        data: response,
      };
    } catch (err) {
      return {
        success: false,
      };
    }
  }, []);

  return {
    getFnsRegistryDateMsp,
  };
}
